module.exports = __webpack_public_path__ + "img/hand_sideleft_42.00dd1ff1.svg";